import { useEffect, useState } from "react";
import { getUnmatchedChildren } from "../utils/normalizeParentMergeData";

const useParentMergeWizard = ({
  show,
  existingParent1,
  newParent1,
  existingParent2,
  newParent2,
  existingChildren,
  newChildren,
}) => {
  const [step, setStep] = useState(1);
  const [parent1Choices, setParent1Choices] = useState({});
  const [parent2Choices, setParent2Choices] = useState({});
  const [childrenChoices, setChildrenChoices] = useState([]);

  useEffect(() => {
    if (!show) return;
    setChildrenChoices(getUnmatchedChildren(existingChildren, newChildren));
  }, [show, existingChildren, newChildren]);

  useEffect(() => {
    if (!show) return;
    setStep(1);
    const incomingChoices = (existing, incoming) =>
      !existing && incoming
        ? Object.keys(incoming).reduce((choices, field) => ({ ...choices, [field]: "new" }), {})
        : {};
    setParent1Choices(incomingChoices(existingParent1, newParent1));
    setParent2Choices(incomingChoices(existingParent2, newParent2));
  }, [show, existingParent1, newParent1, existingParent2, newParent2]);

  return {
    step,
    parent1Choices,
    setParent1Choices,
    parent2Choices,
    setParent2Choices,
    childrenChoices,
    setChildrenChoices,
    goToNextStep: () => setStep((current) => Math.min(current + 1, 3)),
    goToPrevStep: () => setStep((current) => Math.max(current - 1, 1)),
  };
};

export default useParentMergeWizard;
